module.exports = __webpack_public_path__ + "img/banner_4.84f77853.jpg";